import { request } from './request';

export const requestStartChat = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/chat-request?${getParams}`,
    method: 'POST',
    body
  });

export const loginPresale = ({ CHAT_API }, body) =>
  request({
    url: `${CHAT_API}/login-presale`,
    method: 'POST',
    body
  });

export const sendChatMessage = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/send-message?${getParams}`,
    method: 'POST',
    body
  });

export const endChat = ({ CHAT_API, getParams }) =>
  request({
    url: `${CHAT_API}/end-chat?${getParams}`,
    method: 'GET'
  });

export const sendFeedback = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/send-feedback?${getParams}`,
    method: 'POST',
    body
  });

export const sendChatFeedback = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/mark-chat?${getParams}`,
    method: 'POST',
    body
  });

export const sendChatTranscript = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/send-transcript?${getParams}`,
    method: 'POST',
    body
  });

export const submitReviewToThirdParty = ({ CHAT_API, getParams, payload }) =>
  request({
    url: `${CHAT_API}/thankyou-page?${getParams}`,
    method: 'POST',
    body: payload
  });

export const recordFeedbackClick = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/record-feedback-click?${getParams}`,
    method: 'POST',
    body
  });

export const closeChatBeforeAccepted = ({ CHAT_API, getParams }) =>
  request({
    url: `${CHAT_API}/close-chat?${getParams}`,
    method: 'GET'
  });

export const uploadFile = ({ CHAT_API, getParams }, body) =>
  request({
    url: `${CHAT_API}/uploadfile?${getParams}`,
    body,
    method: 'POST'
  });
